import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "user-upload"
};
const _hoisted_2 = {
  class: "reply-text"
};
const _hoisted_3 = {
  key: 0,
  class: "min-[64px]"
};
const _hoisted_4 = {
  class: "text-sm text-[#86909C] leading-[20px] flex justify-between break-all"
};
const _hoisted_5 = {
  key: 1,
  class: "flex-1 flex flex-wrap gap-2"
};
const _hoisted_6 = {
  key: 1,
  class: "footer-tip flex"
};
const _hoisted_7 = {
  key: 2,
  class: "flex justify-end mt-4"
};
import { computed, ref, watch, nextTick } from 'vue';
import { ElMessage } from 'element-plus';
import useAppStore from '@views/app.store';
import { Plus } from '@element-plus/icons-vue';
import { useFileUpload } from '@/hooks/useFileUpload.js';
import { addInformation } from '../../api';
import FileUpload from '../upload/index.vue';
import FileItem from '../upload/FileItem.vue';
import AnimateText from '../AnimateText.vue';
import useMainStore from '../../main.store';
const uploadGuide = 'https://book.marketingforce.com/index.php?s=/63&page_id=1719';
export default /*@__PURE__*/_defineComponent({
  __name: 'OptimizeAIprompt',
  props: {
    item: {},
    content: {}
  },
  setup(__props) {
    const props = __props;
    const mainStore = useMainStore();
    const appStore = useAppStore();
    const AnimateTextRef = ref();
    const show = ref(true);
    const animateLoading = ref(false);
    const info = ref({
      tips: '',
      keyWordDetails: []
    });
    const foldList = ref([]);
    // function foldChange(index: number) {
    //   if (foldList.value.includes(index)) {
    //     foldList.value = foldList.value.filter(item => item !== index)
    //   } else {
    //     foldList.value.push(index)
    //   }
    // }
    // 使用文件上传 hooks
    const fileUpload = useFileUpload({
      accept: ['.zip', '.doc', '.docx', '.ppt', '.pptx', '.xlsx', '.csv', '.pdf'],
      autoUpload: false
    });
    const editable = computed(() => {
      return props.item.id === mainStore.lastFileMsgId;
    });
    // 从 hooks 中解构需要的方法和状态
    const {
      loading,
      fileList,
      uploadConfig,
      handleFileProgress,
      handleUploadState,
      handleUploadComplete,
      handleFilesSelected,
      handleReplace,
      handleRetry,
      setFileUploadRef,
      batchUploadFiles,
      hasFilesToUpload,
      uploadableFilesCount
    } = fileUpload;
    const deleteFilesId = ref([]);
    const isSubmitting = ref(false);
    const sesstionFiles = computed(() => {
      // 104 是预览模式，只显示已上传文件列表，不显示上传按钮
      if (props.item.messageType === 104) {
        return fileList.value.filter(item => item.files.length > 0);
      }
      return fileList.value;
    });
    const showUploadBtn = computed(() => {
      return hasFilesToUpload.value && (uploadableFilesCount.value > 0 || deleteFilesId.value.length > 0) && editable.value || isSubmitting.value;
    });
    function handleEnd() {
      show.value = true;
      animateLoading.value = true;
      setTimeout(() => {
        animateLoading.value = false;
        mainStore.loadNextMsg(props.item);
      }, 2000);
    }
    /**
     * 初始化文件列表
     * @param {Array} list - 文件列表
     */
    const initFileList = list => {
      fileList.value = (list || []).map(item => ({
        ...item,
        files: (item.files || item.attachmentDetails || []).map(file => ({
          ...file
        }))
      }));
    };
    const handleDelete = (item, fileIndex) => {
      if (item.files && item.files.length > fileIndex) {
        const file = item.files[fileIndex];
        // 只有已上传成功的文件才有 fileId，才需要加入删除列表
        if (file.fileId) {
          deleteFilesId.value.push(file.fileId);
        } else if (file?.origin?.fileId) {
          deleteFilesId.value.push(file.origin.fileId);
        }
        item.files.splice(fileIndex, 1);
      }
    };
    const clickUpload = () => {
      fileUpload.manuallyUpload();
    };
    const handleAddInformation = async () => {
      if (fileList.value.length === 0) return;
      let fileString = '';
      const details = fileList.value.map(item => {
        const {
          files,
          ...rest
        } = item;
        const attachmentDetails = files.map(f => {
          const {
            fileName,
            fileSize,
            fileFormat,
            filePath,
            fileId,
            origin
          } = f;
          let replaceFile = {};
          // 替换原文件
          if (f.isReplaced && f.origin.status !== 'ready') {
            replaceFile = {
              originFileId: origin.fileId,
              originFilePath: origin.filePath,
              originFileName: origin.fileName,
              originFileFormat: origin.fileFormat
            };
          }
          return {
            fileName,
            fileSize,
            fileFormat,
            filePath,
            fileId,
            ...f.result,
            ...replaceFile
          };
        });
        const addArr = item?.files.filter(f => !f.fileId) || [];
        if (addArr.length > 0) {
          fileString += `【${item.keyword}】的${addArr.map(f => `【${f.fileName}】`).join('、')}，`;
        }
        return {
          ...rest,
          attachmentDetails
        };
      });
      const params = {
        historyMessageId: props.item.id,
        details,
        sessionId: mainStore.msgParams.sessionId,
        tips: `我想补充/变更${fileString.slice(0, -1)}内容`,
        deleteFiles: deleteFilesId.value
      };
      try {
        await addInformation(params);
        deleteFilesId.value = [];
        ElMessage.success('提交成功');
      } catch (error) {
        console.error('API调用失败:', error);
      } finally {
        isSubmitting.value = false;
      }
    };
    /**
     * 批量上传所有文件
     */
    const handleSubmit = async () => {
      try {
        isSubmitting.value = true;
        const uploadResult = await batchUploadFiles();
        if (!uploadResult.success) {
          return;
        }
        await handleAddInformation();
      } catch (error) {
        console.error('提交过程中发生错误:', error);
        ElMessage.error('提交失败，请重试');
      } finally {
        isSubmitting.value = false;
      }
    };
    // 监听动画状态
    watch(() => props.item.openAnimate, async newVal => {
      if (newVal) {
        await nextTick();
        show.value = false;
        AnimateTextRef.value?.typeWriter(info.value.tips || '');
      }
    }, {
      immediate: true,
      deep: true
    });
    // 监听内容变化并初始化文件列表
    watch(() => props.content, newVal => {
      try {
        const parsedInfo = newVal;
        info.value = parsedInfo;
        initFileList(parsedInfo.keyWordDetails || []);
      } catch (error) {
        info.value = {
          tips: '',
          keyWordDetails: []
        };
        initFileList([]);
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_button = _resolveComponent("el-button");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(AnimateText, {
        ref_key: "AnimateTextRef",
        ref: AnimateTextRef,
        text: __props.item.openAnimate ? '' : info.value.tips,
        onEnd: handleEnd
      }, {
        default: _withCtx(() => [[103, 105].includes(__props.item.messageType) && show.value && !_unref(appStore).isSpecAcc ? (_openBlock(), _createBlock(_component_el_link, {
          key: 0,
          type: "primary",
          href: uploadGuide,
          underline: false,
          target: "_blank"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode(" AI提示词资料上传指南 ", -1)]))]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["text"])]), show.value ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sesstionFiles.value, (son, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "flex flex-col gap-2 mt-4"
        }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", null, _toDisplayString(son.keyword) + "：", 1)]), _createElementVNode("div", {
          class: _normalizeClass(["flex-1 flex flex-wrap gap-2 list-block", {
            'is-fold': foldList.value.includes(index)
          }])
        }, [son.files.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(son.files, (file, fileIndex) => {
          return _openBlock(), _createBlock(FileItem, {
            key: file.id || fileIndex,
            item: file,
            editable: editable.value,
            onReplace: () => _unref(handleReplace)(son, fileIndex, `fileUploadRef-${index}`),
            onDelete: () => handleDelete(son, fileIndex),
            onRetry: () => _unref(handleRetry)({
              ...file,
              itemIndex: index
            }),
            onOpenWindow: file => _ctx.window.open(file.url, '_blank')
          }, null, 8, ["item", "editable", "onReplace", "onDelete", "onRetry", "onOpenWindow"]);
        }), 128)) : _createCommentVNode("", true), !son.files.length && !editable.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[1] || (_cache[1] = [_createElementVNode("p", {
          class: "text-sm text-[#86909C] leading-[48px]"
        }, "暂无附件", -1)]))])) : _createCommentVNode("", true), editable.value ? (_openBlock(), _createBlock(FileUpload, _mergeProps({
          key: 2,
          ref_for: true,
          ref: el => _unref(setFileUploadRef)(`fileUploadRef-${index}`, el)
        }, {
          ref_for: true
        }, _unref(uploadConfig), {
          "file-list": son.files,
          onUploadState: _unref(handleUploadState),
          onUpload: _unref(handleUploadComplete),
          onFileProgress: _unref(handleFileProgress),
          onFilesSelected: (files, currentFile) => _unref(handleFilesSelected)(files, currentFile, son)
        }), {
          trigger: _withCtx(() => [_createVNode(_component_el_tooltip, {
            content: "上传已达文件限制",
            placement: "top",
            disabled: son.files.length < _unref(uploadConfig).maxLimit
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: _normalizeClass(["el-upload el-upload--picture-card", {
                'is-disabled': son.files.length >= _unref(uploadConfig).maxLimit
              }]),
              onClick: clickUpload
            }, [_createVNode(_component_el_icon, {
              class: "w-5 h-5"
            }, {
              default: _withCtx(() => [_createVNode(_unref(Plus))]),
              _: 1
            })], 2)]),
            _: 2
          }, 1032, ["disabled"])]),
          _: 2
        }, 1040, ["file-list", "onUploadState", "onUpload", "onFileProgress", "onFilesSelected"])) : _createCommentVNode("", true)], 2)]);
      }), 128))])), [[_directive_loading, animateLoading.value]]) : _createCommentVNode("", true), [103, 105].includes(__props.item.messageType) ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[2] || (_cache[2] = [_createElementVNode("span", {
        class: "flex-none"
      }, "温馨提示：", -1), _createElementVNode("div", null, [_createElementVNode("p", null, " 1. 提交前请检查资料是否合规、内容是否准确、信息是否完整。这将直接影响AI分析的质量和效果。 "), _createElementVNode("p", null, " 2. 文件支持zip、 doc、 docx、 ppt、 pptx、 xlsx、 csv、 pdf格式， 单个提示词最多上传6个文件。 ")], -1)]))])) : _createCommentVNode("", true), showUploadBtn.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_button, {
        type: "primary",
        loading: _unref(loading),
        disabled: _unref(loading),
        onClick: handleSubmit
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(loading) ? '上传中...' : __props.item.messageType === 103 ? '确认上传' : '确认变更内容'), 1)]),
        _: 1
      }, 8, ["loading", "disabled"])])) : _createCommentVNode("", true)]);
    };
  }
});